import { useQuery } from '@tanstack/react-query'
import { ownerApi } from '../ownerApi.js'

export interface BroadcastCapInfo {
  per_day: number | null
  per_week: number | null
  sent_last_day: number
  sent_last_week: number
  remaining_today: number | null
  remaining_this_week: number | null
}

export const broadcastCapKey = ['owner', 'tenant', 'broadcast-cap'] as const

/**
 * Slice 6 — owner-facing broadcast cap surface. Used on the broadcasts
 * page to show how many sends are left in each window so the owner can
 * pace themselves. Null on remaining_* = unlimited on that window.
 */
export function useBroadcastCap() {
  return useQuery<BroadcastCapInfo>({
    queryKey: broadcastCapKey,
    queryFn: () => ownerApi.get<BroadcastCapInfo>('/tenant/broadcast-cap'),
    staleTime: 30_000,
  })
}
